/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_rlike.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns `true` when any value yielded by `field` matches `pattern`, using the same regular-expression syntax\nas `RLIKE`. The pattern must match a value in full, as with `RLIKE`. `RLIKE` is a single-value scalar:\napplied to a multivalue field it emits a warning and returns `null`, so this is how you match a regular\nexpression against a multivalue field. A null or empty `field` returns `false`, and because the result is\nnever null the predicate composes under `AND`/`OR`/`NOT`.',
  examples: [
    'ROW names = ["Anna", "Bob", "Carl"]\n| EVAL any_starts_with_a = mv_rlike(names, "A.*")',
    'ROW names = ["Anna", "Bob"]\n| EVAL has_three_letter_b_name = mv_rlike(names, "[Bb]ob")',
  ],
  params: {
    field: 'Multivalue expression to test. If null or empty, the function returns `false`.',
    pattern: 'Regular expression. Must be a constant. The pattern must match a value in full, as with `RLIKE`.',
  },
};

export default docs;
